module.exports = __webpack_public_path__ + "static/media/working.765cc1fc.png";